import { render, staticRenderFns } from "./DashCourseOrders.vue?vue&type=template&id=0c8f7d6e&scoped=true&"
import script from "./DashCourseOrders.vue?vue&type=script&lang=js&"
export * from "./DashCourseOrders.vue?vue&type=script&lang=js&"
import style0 from "./DashCourseOrders.vue?vue&type=style&index=0&id=0c8f7d6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8f7d6e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataIterator } from 'vuetify/lib/components/VDataIterator';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VChip,VCol,VDataIterator,VDivider,VIcon,VRow,VSheet})
